module.exports = __webpack_public_path__ + "img/svip_id.2e905463.png";